import React, { useContext } from 'react';
import { Table, Pagination } from 'antd';
import { ParamsContext } from '../../routes/Context/ParamsContext';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import Filter from './Filter';

const Basic = (props) => {
  const { loading, total, pageSize, pathname, columns } = props;
  const params = useContext(ParamsContext);
  const history = useHistory();

  return (
    <>
      {columns.filter(el => el.filter).length ? <Filter columns={columns} pathname={pathname} loading={loading} /> : null}
      <Table
        {...props}
        rowKey={`id`}
        columns={columns.filter(el => el.visible === undefined || el.visible === true)}
        pagination={false}
        bordered={false}
        scroll={{x: 1000}}
        size="large"
        style={{ boxShadow: "0 0 5px 5px rgba(0,0,0,0.03)" }}
        onChange={(pagination, filters, sorter) => {
          if (sorter) {
            let location = {
              pathname: pathname,
              search: queryString.stringify({
                ...params,
                sort: `${sorter.order==='descend' ? '-': ''}${sorter.columnKey}`
              })
            };

            if (sorter.order === undefined) {
              location = {
                pathname: pathname,
                search: queryString.stringify({ ...params, sort: null })
              };
            }

            history.push(location);
          }
        }}
      />
      {loading ? null : <Pagination
        className="gx-mt-3 gx-mb-2"
        defaultCurrent={params.page ? params.page : 1}
        pageSize={pageSize ? pageSize : 10}
        total={total}
        onChange={(page) => {
          history.push({ pathname: pathname, search: queryString.stringify({ ...params, page: page }) });
        }}
      />}
    </>
  );
}

export default Basic;